export const LEAVE_ACTIONS = "LEAVE_ACTIONS";

export const leaveAction = () => {
  return {
    type: LEAVE_ACTIONS,
  };
};
